import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from './store'
import './index.scss';

class expertDetail extends Component {

  componentDidMount() {
    const { id } = this.props.match.params
    if (id) {
      this.props.fetchExpoertData(id);
    }
  }

  render() {
    const { expertDetail } = this.props;
    return (
      <div className="expert">
        <div className="expert__wrap">
          {
            expertDetail && (
              <div className="expert__box">
                <div className="b_img">
                  <img className="expert__pic" src={expertDetail.get('headimg')} alt=""></img>
                </div>
                
                <div className="expert__info">
                  <h2 className="h-title">{expertDetail.get('name')}</h2>
                  <p className="title">{expertDetail.get('rank')}</p>
                  <span className="line"></span>
                  <p className="l-desc">{expertDetail.get('des')}</p>
                </div>
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  expertDetail: state.getIn(['expert', 'expertData']),
});

const mapDispatch = (dispatch) => ({
  fetchExpoertData(id) {
    dispatch(actionCreators.fetchExpertData(id));
  }
});


export default connect(mapState, mapDispatch)(expertDetail);
